import { sanitizeUrl } from '../common/utils';

const callApi = (endpoint: string, options: any = {}) => {
  // Apply security validation to API endpoint
  let sanitizedUrl;
  try {
    // Handle relative URLs by constructing full URL with current domain
    let fullUrl = endpoint.trim(); // Trim whitespace first
    if (fullUrl.startsWith('/')) {
      // For relative URLs, prepend the current origin
      fullUrl = `${window.location.origin}${fullUrl}`;
    } else if (!fullUrl.startsWith('http://') && !fullUrl.startsWith('https://')) {
      // Check if it looks like a domain name (contains dots but doesn't start with /)
      if (fullUrl.includes('.') && !fullUrl.startsWith('/')) {
        // For domain names without protocol, add https://
        fullUrl = `https://${fullUrl}`;
      } else {
        // For other relative paths, prepend the current origin
        fullUrl = `${window.location.origin}/${fullUrl.replace(/^\/+/, '')}`;
      }
    }
    
    sanitizedUrl = sanitizeUrl(fullUrl);
  } catch (error) {
    throw new Error('Failed to sanitize URL: ' + error.message);
  }

  const validatedUrl = (function whitelistUrl() {
    const whiteListUrls = [
      'https://dev.atd.solutions.iqvia.com',
      'https://test.atd.solutions.iqvia.com',
      'https://demo.atd.solutions.iqvia.com',
      'https://formalsvt.atd.solutions.iqvia.com',
      'https://uat.atd.solutions.iqvia.com',
      'https://preprod.atd.solutions.iqvia.com',
      'https://svt.atd.solutions.iqvia.com',
      'https://atd.solutions.iqvia.com',
      'https://dev2.atd.solutions.iqvia.com',
      'https://test2.atd.solutions.iqvia.com',
      'https://demo2.atd.solutions.iqvia.com',
      'https://d16wwzxkz6dosk.cloudfront.net',
      'https://abmepztpslw7qdovszsukagrmq0mhwrh.lambda-url.us-east-1.on.aws',
      'https://tb5cqe57vfkg6hc3psx6ezsba40ihkou.lambda-url.us-east-1.on.aws',
      'https://uf5fr5tzc6otuhsvg5ec2rpvry0ifqwf.lambda-url.us-east-1.on.aws',
      'https://fbus2anlay2oynqykfyt24kthm0hrmqc.lambda-url.us-east-1.on.aws',
      'https://iktqw46z2gghctxrn63adpemsq0pseqx.lambda-url.us-east-1.on.aws',
      'https://hpkvuw6f3ljompsyfsh23gvycq0tukvm.lambda-url.us-east-1.on.aws'
    ];

    const urlToBeScanned = sanitizedUrl;

    const parsedUrl = new URL(urlToBeScanned);
    const hostname = parsedUrl.hostname;

    // Check if hostname matches any whitelisted domain
    const isWhitelisted = whiteListUrls.some((whitelistedUrl) => {
      try {
        const whitelistedHostname = new URL(whitelistedUrl).hostname;
        console.log('whitelistedHostname', whitelistedHostname);
        console.log('hostname', hostname);
        return hostname === whitelistedHostname;
      } catch {
        // For non-URL entries (just hostnames), compare directly
        return hostname === whitelistedUrl;
      }
    });

    return isWhitelisted ? sanitizedUrl : null;
  })();

  if (!validatedUrl) {
    throw new Error('URL not whitelisted for security reasons');
  }

  // Use a mutable variable for URL manipulation
  let finalUrl = validatedUrl;

  options = {
    ...options,
    headers: {
      ...options.headers,
      'Authorization':  sessionStorage.getItem('authToken') && `Bearer ${sessionStorage.getItem('authToken')}`,
    }
  }

  // TODO: Remove check after clearning tenantid addition from other places
  if (shouldAddTenantid(finalUrl)) {
    const tenantid = sessionStorage.getItem('tenantid');
    finalUrl += finalUrl.includes('?') ? `&tenantid=${tenantid}` : `?tenantid=${tenantid}`;    
  }

  return fetch(finalUrl, options)
    .then((res) => {
      return res.json()
    })
    .then((response) => {
      if (response.message === 'Successful' || response.success === true || response.success === false || response.data || (typeof response === 'string' && response.includes('WarmUp - Lambda is warm!'))) {
        return response;
      }
      throw response;
    });
}

function shouldAddTenantid(endpoint: string) {
  return !endpoint.includes('tenantid=') && sessionStorage.getItem('tenantid')
}

export { callApi }